import { api } from "./api";

export const productListsApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getProductLists: builder.query({
      query: ({
        limit = 20,
        page = 1,
        slug = "",
        brandIds = "",
        isLuxury,
        minPrice = "",
        maxPrice = "",
        onDisplay = "",
        isAvailabilty = "",
        inStore = "",
        fieldIds = "",
        fieldValueIds = "",
        filterSubCategoryId = "",
        categoryIds,
        subCategoryIds,
        subCategory2Ids,
        criteriaId,
        keyword = "",
        tag,
        sort = "",
        order = "",
        rebateIds = "",
        dimensions = "",
        zipCode = "",
        deliveryDate = "",
        onSale = "",
        clearance = "",
        rebateAvailable = "",
        storeId = "",
        deliveryRouteId = "",
        height = "",
        width = "",
        depth = "",
        totalCapacity = "",
        iceCapacity = "",
        dailyIceProduction = "",
        ovenCapacity = "",
        washerHeight = "",
        washerWidth = "",
        washerDepth = "",
        dryerHeight = "",
        dryerWidth = "",
        dryerDepth = "",
        capacity = "",
        setProductCategoryIds="",
      }) => ({
        url: `/filterProducts?limit=${limit}&page=${page}&keyword=${keyword}&tag=${tag}&slug=${slug}&isLuxury=${isLuxury}&categoryIds=${categoryIds}&subCategoryIds=${subCategoryIds}&criteriaId=${criteriaId}&subCategory2Ids=${subCategory2Ids}&brandIds=${brandIds}&minPrice=${minPrice}&maxPrice=${maxPrice}&onDisplay=${onDisplay}&isAvailabilty=${isAvailabilty}&fieldIds=${fieldIds}&fieldValueIds=${fieldValueIds}&filterSubCategoryId=${filterSubCategoryId}&sort=${sort}&order=${order}&rebateIds=${rebateIds}&dimensions=${dimensions}&inStore=${inStore}&zipCode=${zipCode}&deliveryDate=${deliveryDate}&onSale=${onSale}&clearance=${clearance}&rebateAvailable=${rebateAvailable}&storeId=${storeId}&deliveryRouteId=${deliveryRouteId}&height=${height}&width=${width}&depth=${depth}&totalCapacity=${totalCapacity}&iceCapacity=${iceCapacity}&dailyIceProduction=${dailyIceProduction}&ovenCapacity=${ovenCapacity}&washerHeight=${washerHeight}&washerWidth=${washerWidth}&washerDepth=${washerDepth}&dryerHeight=${dryerHeight}&dryerWidth=${dryerWidth}&dryerDepth=${dryerDepth}&capacity=${capacity}&setProductCategoryIds=${setProductCategoryIds}`,
        providesTags: ["products"],
      }),
      // serializeQueryArgs: ({ endpointName, queryArgs }) => {
      //   // Serialize query args to cache based on slug
      //   return `${endpointName}-${queryArgs.slug}-${queryArgs.brandIds}-${queryArgs.minPrice}-${queryArgs.maxPrice}-${queryArgs.onDisplay}-${queryArgs.isAvailabilty}-${queryArgs.fieldIds}-${queryArgs.fieldValueIds}-${queryArgs.filterSubCategoryId}-${queryArgs.keyword}-${queryArgs.sort}-${queryArgs.order}-${queryArgs.rebateIds}`;
      // },
      // // merge: (currentCache, newItems) => {
      // //   // Return if there's no new data
      // //   if (!newItems || newItems.data.length === 0) {
      // //     currentCache.isNotFound = true; // Flag when no data
      // //     return;
      // //   }

      // //   // Return newItems if currentCache data already meets length threshold
      // //   if (currentCache?.data?.length >= 24) {
      // //     return newItems;
      // //   }

      // //   // Update pagination and merge new data into currentCache
      // //   currentCache.pagination = newItems.pagination;
      // //   currentCache.data.push(...newItems.data);
      // // },
      // forceRefetch: ({ currentArg, previousArg }) => {
      //   if (!previousArg) return true;
      //   return (
      //     currentArg.page !== previousArg.page ||
      //     currentArg.slug !== previousArg.slug ||
      //     currentArg.brandIds !== previousArg.brandIds ||
      //     currentArg.minPrice !== previousArg.minPrice ||
      //     currentArg.maxPrice !== previousArg.maxPrice ||
      //     currentArg.onDisplay !== previousArg.onDisplay ||
      //     currentArg.isAvailabilty !== previousArg.isAvailabilty ||
      //     currentArg.fieldIds !== previousArg.fieldIds ||
      //     currentArg.fieldValueIds !== previousArg.fieldValueIds ||
      //     currentArg.filterSubCategoryId !== previousArg.filterSubCategoryId ||
      //     currentArg.keyword !== previousArg.keyword ||
      //     currentArg.sort !== previousArg.sort ||
      //     currentArg.order !== previousArg.order ||
      //     currentArg.rebateIds !== previousArg.rebateIds
      //   );
      // },
    }),

    getCompareProducts: builder.query({
      query: ({ id, type }) => `/compareProducts?id=${id}&type=${type}`,
    }),

    getViewedProducts: builder.query({
      query: (categoryId) => {
        const params = categoryId ? `?categoryId=${categoryId}` : "";
        return `/getReviewProducts${params}`;
      },
    }),
  }),
});

export const {
  useGetProductListsQuery,
  useGetCompareProductsQuery,
  useGetViewedProductsQuery,
} = productListsApiSlice;
